(function (upp, $) {
    'use strict';
    upp

//TODO: Test!!!
//Execute function passed as parameter when scroll
//Parameters:
// * infinite-scroll-func: {Function} function to execute when scroll or if initialization is enabled
// * infinite-scroll-busy: {Boolean} if true, scroll func is not executed
// * infinite-scroll-init-when: {Boolean} if true, initialization start: scroll func is called while there is no scrollbar and stop trigger
// * infinite-scroll-stop-when: {Boolean} if true, initialization stop
// * infinite-scroll-more-button: {Boolean} if true, more elements button is shown

        .directive('infiniteScrollFunc', ['translator',
        function (translator) {

            var scrollSection,
                raw;

            var scrollBarIsVisibleEnough = function () {
                return scrollSection.get(0).scrollHeight > scrollSection.height() + 200;
            };

            return function (scope, elm, attr) {

                var button,
                    message;

                scrollSection = scrollSection || $('#content-wrapper');
                raw = raw || scrollSection[0];

                var isNotBusy = (function () {
                    var busyScopeVariable = attr.infiniteScrollBusy;
                    return function () {
                        return  !busyScopeVariable || !scope.$eval(busyScopeVariable)
                    }
                })();

                var stopInit = (function () {
                    var initStopScopeVariable = attr.infiniteScrollWithoutStopWhen;
                    return function () {
                        return scope.$eval(initStopScopeVariable)
                    }
                })();

                var execScrollFunc = function () {
                    scope.$eval(attr.infiniteScrollFunc);
                };


                scrollSection.bind('scroll', function () {

                    if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight - 50) {
                        if (isNotBusy()) {
                            execScrollFunc();
                        }
                    }
                });


                //Manual initialization: Instead of waiting scroll, while there is no scroll, launch the search
                if (attr.infiniteScrollWithoutInitWhen && attr.infiniteScrollWithoutStopWhen) {

                    var initWithoutScroll = (function () {

                        var times = 0,
                            MAX = 5;

                        return function () {
                            //if:
                            //0º 5 Max times to execute
                            //1º scroll bar is hidden
                            //2º stop initialization trigger is set to false

                            if (times < MAX && !scrollBarIsVisibleEnough() && !stopInit()) {

                                //don't execute if service is busy (disabled)
                                if (isNotBusy()) {
                                    times++;
                                    execScrollFunc();
                                }
                                setTimeout(initWithoutScroll, 100);
                            }
                        }
                    })();

                    //If there is no scroll bar, when init, should try to request more items
                    scope.$watch(attr.infiniteScrollWithoutInitWhen, function (shouldInitNow) {
                        if (shouldInitNow === true) {
                            initWithoutScroll();
                        }
                    })
                }

                if (attr.infiniteScrollBusy) {
                    message = $('<div/>', {
                        text:translator.i18n('LOADING2')
                    })
                        .addClass('infinite-scroll-loading-data')
                        .appendTo(elm);

                    scope.$watch(attr.infiniteScrollBusy, function (isBusy) {
                        if (isBusy === true) {
                            button.hide();
                            message.show();
                        } else {
                            message.hide();
                            button.show();
                        }
                    });
                }
                if (attr.infiniteScrollMoreButton) {

                    var buttonWrapper = $('<div/>')
                        .addClass('infinite-scroll-more-wrapper')
                        .appendTo(elm);

                    button = $('<button/>', {
                        text:translator.i18n('MORE_ELEMENTS')
                    })
                        .addClass('btn infinite-scroll-more')
                        .appendTo(buttonWrapper);

                    button.click(function () {
                        if (isNotBusy()) {
                            execScrollFunc();
                        }
                    });

                    scope.$watch(attr.infiniteScrollMoreButton, function (moreElements) {
                        if (moreElements  === true ) { //if there is more elements and is not busy (waiting server for more data)
                            if (isNotBusy()){
                                button.show();
                                message.hide();
                            }else{
                                button.hide();
                                message.show();
                            }

                        } else {
                            button.hide();
                            message.hide();
                        }
                    })
                }
            };
        }]);


})(upp, jQuery);


// WEBPACK FOOTER //
// ./src/app/common/directives/infinite_scroll-directive.js